import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Real situations" className="border-y border-grape/10 bg-white/70" data-id="element-119" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-120" data-mp="26xmth5ntjug4">
        <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-121" data-mp="2bvobrodf7pqj">
          Real situations
        </p>
        <h2 className="mt-3 text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-122" data-mp="21zcvyoemghrc">
          Does this also happen in your home?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-123" data-mp="1o14sdxn2yi77">
          You already know what your child has to do each day. The problem is that the routine only
          exists in your head, so every step needs you to announce it, repeat it and remind it
          again.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-blush" data-id="element-124" data-mp="3nalc3uf221d7">
          It is not a discipline problem. It is a visibility problem.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-125" data-mp="1u0skcfud7fux">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-126" data-mp="27rxgv92frs11" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-127" data-mp="1p0ecaxsrk5ww">
                {p.emoji}
              </span>
              <div data-id="element-128" data-mp="30ftb874j97un">
                <h3 className="text-sm font-bold text-plum" data-id="element-129" data-mp="30jh5j8hsxyaf">
                  <span className="mr-1.5 font-display text-xs font-black text-blush" data-id="element-130" data-mp="2vi1ijaw2dhpe">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  {p.title}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-131" data-mp="1y2ey7iso6zho">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-132" data-mp="274o600wk0erd">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-133" data-mp="274ef8b3oq3km">
            ✨ If you recognized your home, this is for you.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-134" data-mp="1efzb4jm3d5o2">
            The next 30 days can sound completely different.
          </p>
        </div>
      </div>
    </section>;
}